'use client'

import { useEffect } from 'react'
import {
    getWebInstrumentations,
    initializeFaro,
    isInternalFaroOnGlobalObject,
} from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

export default function FaroInit() {
    useEffect(() => {
        if (isInternalFaroOnGlobalObject()) return

        initializeFaro({
            url: 'https://faro-collector-prod-eu-north-0.grafana.net/collect/42ad8062f36582268ef517ada34901a8',
            app: {
                name: 'peek-product-frontend',
                version: '1.0.0',
                environment: process.env.NODE_ENV,
            },
            instrumentations: [
                ...getWebInstrumentations(),
                new TracingInstrumentation(),
            ],
        })
    }, [])

    return null
}
